import {
  ButtonGroup, createListCollection, Flex, IconButton,
  Pagination, Portal, Select, Text,
} from '@chakra-ui/react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';

type Props = {
  limit: number,
  total: number,
  page: number,
  onPaginationChange: (page: number, limit: number) => void,
};

const limits = createListCollection({
  items: [
    { label: '10', value: '10' },
    { label: '20', value: '20' },
    { label: '50', value: '50' },
    { label: '100', value: '100' },
  ],
});

const PaginationContainer = ({ limit, total, page, onPaginationChange }: Props) => (
  <Flex justifyContent={{ base: 'center', md: 'space-between' }} my={8} flexWrap="wrap" gap={4}>
    <Flex alignItems="center" gap={2} minWidth={240} width={240}>
      <Text textStyle="xs">
        Mostrando
      </Text>

      <Select.Root
        collection={limits}
        size="xs"
        variant="subtle"
        value={[limit.toString()]}
        onValueChange={(e) => {
          onPaginationChange(1, Number(e.value[0]));
        }}
      >
        <Select.HiddenSelect />
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
          </Select.IndicatorGroup>
        </Select.Control>
        <Portal>
          <Select.Positioner>
            <Select.Content>
              {limits.items.map((framework) => (
                <Select.Item item={framework} key={framework.value}>
                  {framework.label}
                  <Select.ItemIndicator />
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Positioner>
        </Portal>
      </Select.Root>

      <Text textStyle="xs" whiteSpace="nowrap">
        de {total} resultado(s)
      </Text>
    </Flex>

    <Pagination.Root
      count={total}
      pageSize={limit}
      page={page}
      onPageChange={(e) => onPaginationChange(e.page, limit)}
    >
      <ButtonGroup variant="ghost" size={{ base: 'xs', md: 'sm' }} gap={0}>
        <Pagination.PrevTrigger asChild>
          <IconButton>
            <HiChevronLeft />
          </IconButton>
        </Pagination.PrevTrigger>

        <Pagination.Items
          render={(page) => (
            <IconButton variant={{ base: "ghost", _selected: "outline" }}>
              {page.value}
            </IconButton>
          )}
        />

        <Pagination.NextTrigger asChild>
          <IconButton>
            <HiChevronRight />
          </IconButton>
        </Pagination.NextTrigger>
      </ButtonGroup>
    </Pagination.Root>
  </Flex>
);

export default PaginationContainer;
